const MAX_QUANTITY_LIMIT = 99;
const PLACEHOLDER = '---';
const POWER_ZERO = '0.00';

export { MAX_QUANTITY_LIMIT, PLACEHOLDER, POWER_ZERO };
//# sourceMappingURL=constants.js.map
